import { gql } from "@apollo/client";

export const FETCH_STOCK_CATEGORIES = gql`
  query FETCH_STOCK_CATEGORIES {
    stockCategories {
      id
      name
      notes
    }
  }
`;

export const FETCH_STOCK_CATEGORY = gql`
  query FETCH_STOCK_CATEGORY($stockCategoryId: ID!) {
    stockCategory(id: $stockCategoryId) {
      id
      name
      stocks {
        id
        name
        number
        asin
        barcode
        qtyPerMaster
        unitCost

        product {
          id
          odooId
          name
          number
          itemsPerSet
        }
        initialQty
      }

      inbounds {
        id
        name
        eta
        lines {
          id
          stock {
            id
            name
            number
          }
          qty
        }
      }

      stockReserves {
        id
        reserveId
        shipmentLine {
          id
          shipment {
            id
            refName
          }
        }
        qty
      }
    }
    stockCategoryLatestStocks(stockCategoryId: $stockCategoryId)
  }
`;

export const FETCH_STOCK_CHECK_ALC_STOCKS = gql`
  query FETCH_STOCK_CHECK_ALC_STOCKS($stockCategoryId: ID!) {
    stockCategory(id: $stockCategoryId) {
      id
      name
    }
    stockCheckAlcStocks(stockCategoryId: $stockCategoryId)
  }
`;

export const FETCH_PRODUCTS_FOR_WAREHOUSE = gql`
  query FETCH_PRODUCTS_FOR_WAREHOUSE {
    products(productType: "normal", hasOdooId: true) {
      results {
        id
        name
        number
        version
        countryCodeOfOrigin
        itemsPerSet
      }
    }
  }
`;
